module.exports = __webpack_public_path__ + "img/75738.f0f31f92.svg";